import type { ReactNode } from "react";
import { SnackbarProvider } from "notistack";
import { KardaToast } from "./KardaToast";

/**
 * App-level toast provider. Mounted once in App.tsx (inside ThemeProvider) —
 * never wrap subtrees in their own SnackbarProvider.
 *
 * Positioning: top-center, offset below the app bar and horizontally
 * centered over the content area via the .karda-toast-container CSS rule in
 * index.css, driven by --karda-toast-shift (written by ToastOffsetSync,
 * which can read the sidebar state this provider sits above).
 */
export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <SnackbarProvider
      maxSnack={3}
      preventDuplicate
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      Components={{
        default: KardaToast,
        success: KardaToast,
        error: KardaToast,
        warning: KardaToast,
        info: KardaToast,
      }}
      classes={{ containerAnchorOriginTopCenter: "karda-toast-container" }}
    >
      {children}
    </SnackbarProvider>
  );
}
